// src/components/popups/DeleteOrderDrawer.js

import React from 'react';
import './DeleteOrderDrawer.css';

function DeleteOrderDrawer({ visible, onClose, onConfirm }) {
  if (!visible) return null;

  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="drawer-panel" onClick={(e) => e.stopPropagation()}>
        <h3>Delete Order</h3>
        <p className="drawer-message">
          Are you sure you want to remove this order from your list?
        </p>

        <div className="drawer-actions">
          <button className="drawer-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="drawer-confirm" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteOrderDrawer;
